export const LINK = 'LINK_COMPONENT';
export const POP_UP = 'POPUP_COMPONENT';
export const CO_BROWSE = 'CO_BROWSE_COMPONENT';
export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
export const ITEM_STYLE_LEFT = 'li-left';
export const ITEM_STYLE_RIGHT = 'li-right';
export const STYLE_COPYRIGHT = 'copyright';